// removed by extract-text-webpack-plugin
module.exports = {"waterWave":"antd-pro-charts--water-wave-waterWave","text":"antd-pro-charts--water-wave-text","waterWaveCanvasWrapper":"antd-pro-charts--water-wave-waterWaveCanvasWrapper"};


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/src/components/Charts/WaterWave/index.less
// module id = 590
// module chunks = 0